/*
  GADGETNOVA — header micro-interactions.
  Adds the subtle "bounce" pulse to the cart badge on every cart update,
  per the playbook's CART ICON spec ("badge should bounce slightly").
  Relies on the theme's existing pub/sub bus (assets/pubsub.js + constants.js).
*/
document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    document.querySelectorAll('.cart-count-bubble').forEach(function (badge) {
      badge.classList.remove('gn-bump');
      // Restart the animation even if it's already mid-flight.
      // eslint-disable-next-line no-unused-expressions
      badge.offsetWidth;
      badge.classList.add('gn-bump');
    });
  });
});
